import { createFileRoute, redirect } from "@tanstack/react-router";
import { LoginForm } from "@/components/auth/LoginForm";

interface LoginSearch {
  redirect?: string;
}

export const Route = createFileRoute("/login")({
  validateSearch(raw: Record<string, unknown>): LoginSearch {
    return {
      redirect: typeof raw.redirect === "string" ? raw.redirect : undefined,
    };
  },
  // Guest-only: already-authed users go home (spec §15.9).
  beforeLoad: ({ context }) => {
    if (!context.auth.isLoading && context.auth.isAuthenticated) {
      throw redirect({ to: "/" });
    }
  },
  component: LoginPage,
});

function LoginPage() {
  const { redirect } = Route.useSearch();
  return <LoginForm redirectTo={redirect} />;
}
